/**
 * The web addresses in a block of free text, ready to use as hrefs.
 *
 * A quick submission's description is usually just a gallery link (Pic-Time,
 * Dropbox, Google Drive...) plus a note. It lives in a textarea, which can't
 * hold a clickable link, so editors were copying it out by hand (STY-761).
 *
 * Catches http(s):// and bare www. addresses; a bare www. one gets https://.
 * Trailing sentence punctuation is dropped so "see dropbox.com/x." links to
 * the gallery, not a 404. A closing bracket is dropped only when the URL
 * didn't open it, so "(https://a.com/x)" loses it but ".../Style_(arts)"
 * keeps it. Duplicates are listed once.
 */
const LINK_PATTERN = /(?:https?:\/\/|www\.)[^\s<>"']+/gi
const TRAILING_PUNCTUATION = /[.,;:!?]+$/
const BRACKET_PAIRS = { ')': '(', ']': '[', '}': '{' }

const count = (text, char) => text.split(char).length - 1

const trimTrailing = (link) => {
  let trimmed = link.replace(TRAILING_PUNCTUATION, '')
  let last = trimmed[trimmed.length - 1]
  while (BRACKET_PAIRS[last] && count(trimmed, last) > count(trimmed, BRACKET_PAIRS[last])) {
    trimmed = trimmed.slice(0, -1).replace(TRAILING_PUNCTUATION, '')
    last = trimmed[trimmed.length - 1]
  }
  return trimmed
}

export const extractLinks = (text) => {
  const matches = (text || '').match(LINK_PATTERN) || []
  const links = matches
    .map(trimTrailing)
    .map((link) => (/^https?:\/\//i.test(link) ? link : `https://${link}`))
  return [...new Set(links)]
}

export default extractLinks
